import { LEGAL_LINKS, POLICY_VERSION } from './legalLinks';

export const LEGAL_OPERATOR = {
  name: 'ООО «Успенский Технологии»',
  email: 'hi@antologia.tech',
  site: 'https://antologia.tech',
};

export const privacySections = [
  {
    id: 'operator',
    title: '1. Оператор персональных данных',
    paragraphs: [
      `Оператор: ${LEGAL_OPERATOR.name}. Сайт: ${LEGAL_OPERATOR.site}.`,
      `Контакт по вопросам обработки персональных данных: ${LEGAL_OPERATOR.email}.`,
      `Версия документа: ${POLICY_VERSION}. Актуальная версия всегда доступна на странице ${LEGAL_LINKS.privacy}.`,
    ],
  },
  {
    id: 'purposes',
    title: '2. Цели и категории персональных данных',
    paragraphs: [
      'Мы обрабатываем персональные данные для следующих целей:',
    ],
    list: [
      'обработка заявок на обратный звонок, расчёт стоимости, консультации и лиды с чек-листов (имя, телефон, email, компания, ИНН — по мере заполнения формы);',
      'регистрация и ведение личного кабинета (email, данные профиля компании);',
      'оформление заказов и исполнение договора (контактные и реквизиты организации);',
      'направление уведомлений по заказу и ответы на обращения;',
      'улучшение сайта и аналитика посещений — только при отдельном согласии на cookies (см. политику cookies).',
    ],
  },
  {
    id: 'legal-basis',
    title: '3. Правовые основания',
    paragraphs: [
      'Обработка осуществляется на основании согласия субъекта персональных данных (ст. 9 152-ФЗ), а также для исполнения договора и законных интересов оператора в случаях, предусмотренных законодательством РФ.',
    ],
  },
  {
    id: 'third-parties',
    title: '4. Передача третьим лицам',
    paragraphs: [
      'Данные могут передаваться подрядчикам, действующим по поручению оператора и обеспечивающим хостинг, доставку email, техническую поддержку сайта. При включении аналитики Яндекс.Метрика обрабатывает обезличенные и/или псевдонимизированные данные о посещениях в соответствии с политикой Яндекса.',
    ],
  },
  {
    id: 'storage',
    title: '5. Сроки хранения',
    paragraphs: [
      'Данные заявок и заказов хранятся в течение срока, необходимого для целей обработки и исполнения обязательств, но не дольше, чем это требуется законодательством. Журнал фиксации согласий хранится для подтверждения факта согласия.',
    ],
  },
  {
    id: 'rights',
    title: '6. Права субъекта данных',
    paragraphs: [
      'Вы вправе запросить доступ к своим данным, их уточнение, блокирование или удаление, а также отозвать согласие, направив обращение на ' +
        LEGAL_OPERATOR.email +
        '. Мы ответим в сроки, установленные законодательством РФ.',
    ],
  },
  {
    id: 'withdrawal',
    title: '7. Отзыв согласия',
    paragraphs: [
      'Отзыв согласия не влияет на законность обработки, осуществлённой до отзыва. Отзыв аналитических cookies можно выполнить через настройки баннера на сайте или очистив localStorage браузера.',
    ],
  },
  {
    id: 'pdf',
    title: '8. Архивная версия (PDF)',
    paragraphs: [
      'Ранее опубликованная версия документа доступна для скачивания по ссылке в футере сайта. При расхождении приоритет имеет текст на данной странице.',
    ],
  },
];

export const cookiesSections = [
  {
    id: 'what',
    title: '1. Что такое cookies',
    paragraphs: [
      'Cookies — небольшие файлы, которые сайт или сервисы сохраняют в браузере. Они помогают запоминать настройки, поддерживать сессию и анализировать использование сайта.',
    ],
  },
  {
    id: 'essential',
    title: '2. Обязательные cookies',
    paragraphs: [
      'Эти cookies необходимы для работы сайта и не требуют отдельного согласия:',
    ],
    list: [
      'сессия корзины и гостевой идентификатор;',
      'токен авторизации в личном кабинете (при входе);',
      'сохранение выбора по cookie-баннеру (cookie_consent_v1 в localStorage).',
    ],
  },
  {
    id: 'analytics',
    title: '3. Аналитические cookies (Яндекс.Метрика)',
    paragraphs: [
      'После нажатия «Принять аналитику» загружается счётчик Яндекс.Метрики (ID 109694146). Могут использоваться cookies вида _ym_*, yandexuid, yuidss и др.',
      'Включены: карта кликов, вебвизор (запись действий на странице), отслеживание ссылок, ecommerce. Данные обрабатываются Яндексом в соответствии с документацией: https://yandex.ru/support/metrica/',
    ],
  },
  {
    id: 'control',
    title: '4. Как управлять cookies',
    paragraphs: [
      'При первом визите вы можете выбрать «Только необходимые» — аналитика не загрузится. Выбор сохраняется в браузере. Очистка данных сайта сбросит настройку.',
      'Подробнее об обработке персональных данных — на странице политики конфиденциальности.',
    ],
  },
];
